import customAxios from "../api/interceptors";

export const searchClientForEmailService = (clientEmail: string) => customAxios.get(`/user/manager/request-free-client-companies?clientEmail=${clientEmail}&per-page=500`)

export const assignManagerToCompanyService = (company_id: number) => customAxios.post(`/user/manager/assign-manager-to-company`, { company_id })